export default "__VITE_ASSET__CbfkNy8I__"